module.exports = __webpack_public_path__ + "assets/Retina-Black.772fed4b5c80a8e9415e383459e79b2e.woff2";